import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { FaEdit } from "react-icons/fa";

import { StyledSwitch } from "../../../common/component/StyledSwitch";
import { NetworksField } from "./NetworksField";

export const AdminEditModal = ({ show, rejectChange, adminUser, saveChanges }) => {
  const initialState = {
    name: null,
    email: null,
    phone: null,
    networks: [],
    active: null,
  };
  const [updates, setUpdates] = useState({ ...initialState });

  useEffect(() => {
    if (adminUser && adminUser.networks) {
      updateNetworks(
        adminUser.networks.map((x) => ({
          key: x.networkId,
          value: x.networkId,
          text: x.name,
        }))
      );
    }
  }, [adminUser]);

  if (!adminUser) {
    return null;
  }

  function handleUpdate(fieldName, value) {
    setUpdates({ ...updates, [fieldName]: value });
  }

  function updateNetworks(networks) {
    setUpdates({ ...updates, networks });
  }

  function closeModal() {
    setUpdates(initialState);
    rejectChange();
  }

  const editable = adminUser.identities.indexOf("ACC") === -1;
  return (
    <Modal show={show} onHide={closeModal}>
      <Modal.Header closeButton>
        <Modal.Title>Edit Administrator</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/*<EditAbleField*/}
        {/*  fieldName="Name"*/}
        {/*  fieldValue={adminUser.name}*/}
        {/*  editable={false}*/}
        {/*  handleUpdate={(e) => handleUpdate("name", e)}*/}
        {/*/>*/}
        {/*<EditAbleField*/}
        {/*  fieldName="Email"*/}
        {/*  fieldValue={adminUser.email}*/}
        {/*  editable={false}*/}
        {/*  handleUpdate={(e) => handleUpdate("email", e)}*/}
        {/*/>*/}
        {/*<EditAbleField*/}
        {/*  fieldName="Phone"*/}
        {/*  fieldValue={adminUser.phone}*/}
        {/*  editable={editable}*/}
        {/*  handleUpdate={(e) => handleUpdate("phone", e)}*/}
        {/*/>*/}
        <EditAbleField
          fieldName="Enabled"
          fieldValue={adminUser.enabled}
          type="boolean"
          editable
          handleUpdate={(e) => handleUpdate("active", e)}
        />
        <NetworksField networks={updates.networks} updateNetworks={updateNetworks} editable={editable} />
      </Modal.Body>

      <Modal.Footer>
        <Button
          onClick={() => {
            const updateNetworks = updates.networks.map((x) => x.key);
            const existingUserNetworks = adminUser.networks ? adminUser.networks.map((x) => x.networkId) : [];

            // create remove list of networks
            const toRemoveNetworkIds = existingUserNetworks.filter((x) => !updateNetworks.includes(x));

            // create add list of networks
            const toAddNetworkIds = updateNetworks.filter((x) => !existingUserNetworks.includes(x));

            const newUpdate = { ...updates };

            updates.networks.add = toAddNetworkIds;
            updates.networks.remove = toRemoveNetworkIds;

            saveChanges(adminUser.adminId, newUpdate);
            setUpdates(initialState);
          }}
        >
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const EditAbleField = ({ fieldName, fieldValue, type = "text", handleUpdate, editable }) => {
  const [editing, setEditing] = useState(false);
  const [updatedValue, setUpdatedValue] = useState(fieldValue);

  function handleOnChange(e) {
    if (type === "boolean") {
      handleUpdate(e);
      setUpdatedValue(e);
    } else {
      handleUpdate(e.target.value);
      setUpdatedValue(e.target.value);
    }
  }

  if (type === "boolean") {
    return (
      <div>
        {fieldName}: <StyledSwitch active={updatedValue} toggleActive={handleOnChange} />
      </div>
    );
  }

  if (editing) {
    if (type === "text") {
      return (
        <div>
          {fieldName}: <input type="text" value={updatedValue} onChange={handleOnChange} />
        </div>
      );
    }
  }

  return (
    <div>
      {fieldName}: {updatedValue} {editable ? <FaEdit onClick={() => setEditing(true)} /> : null}
    </div>
  );
};
